import styled from 'styled-components';
import { ifProp } from 'styled-tools';

const Column = styled.div`
  ${ifProp('span', ({ start, span }) => {
    if (start) {
      return `grid-column: ${start} / span ${span} !important;`;
    }

    return `grid-column: span ${span} !important;`;
  })}

  ${ifProp(
    'justifyContent',
    ({ justifyContent }) => `
      display: flex;
      flex-wrap: wrap;
      justify-content: ${justifyContent};
    `
  )}

  ${ifProp(
    'flexDirection',
    ({ flexDirection }) => `
      flex-direction: ${flexDirection};
    `
  )}

  ${ifProp('verticalAlign', ({ verticalAlign }) => `align-items: ${verticalAlign};`)}

  ${ifProp(
    'alignItems',
    ({ alignItems }) => `
      display: flex;
      flex-wrap: wrap;
      align-items: ${alignItems};
    `
  )}

  ${ifProp('outline', () => `outline: solid red 1px;`)}

  ${ifProp('cursor', ({ cursor }) => `cursor: ${cursor};`)}

  ${ifProp('order', ({ order }) => `order: ${order};`)}

  > * {
    grid-column: 1 / -1;
  }

  &.segment-summary-outbound {
    padding-right: 50px;
  }

  &.segment-summary-inbound {
    border-left: solid 1px rgb(188, 188, 188);
    padding-left: 50px;
  }
`;

export default Column;
